import { PageContainer } from "@/components";
import GeneralTab from "@/components/Settings/GeneralTab";
import IntegrationsTab from "@/components/Settings/IntegrationsTab";
import NotificationsTab from "@/components/Settings/NotificationsTab";
import SecurityTab from "@/components/Settings/SecurityTab";
import RolesAndPermissionsTab from "@/components/Settings/RolesAndPermissionsTab";
import SettingsTabs from "@/components/Settings/SettingsTabs";
import useTabFromUrl from "@/hooks/useTabFromUrl";

const TABS = [
  { value: "general", label: "General", content: <GeneralTab /> },
  {
    value: "notifications",
    label: "Notifications",
    content: <NotificationsTab />,
  },
  { value: "security", label: "Security", content: <SecurityTab /> },
  { value: "roles", label: "Roles & Permissions", content: <RolesAndPermissionsTab /> },
  {
    value: "integrations",
    label: "Integrations",
    content: <IntegrationsTab />,
  },
] as const;

export type TabValue = (typeof TABS)[number]["value"];

const Settings = () => {
  const { tab, setTab } = useTabFromUrl<TabValue>({
    param: "tab",
    defaultTab: "general",
    tabs: TABS.map((t) => t.value),
  });

  return (
    <PageContainer>
      <div className="space-y-1">
        <h1 className="text-3xl font-extrabold tracking-tight text-gray-900">
          Settings
        </h1>
        <p className="text-sm font-semibold text-gray-400">
          Manage your application preferences and configurations
        </p>
      </div>

      <SettingsTabs tabs={TABS} activeTab={tab} onTabChange={setTab} />
    </PageContainer>
  );
};

export default Settings;
